module.exports = __webpack_public_path__ + "static/l2-hero-bg-prev-xs-6640cca54a4de9bc8dcd3e69bfb28db9.jpg";